import { Outlet } from 'react-router-dom'

const Onboarding = () => <Outlet />

export default Onboarding
